import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApisService } from 'src/app/service/APIs/apis.service';

@Component({
  selector: 'app-training-development',
  templateUrl: './training-development.component.html',
  styleUrls: ['./training-development.component.scss'],
})
export class TrainingDevelopmentComponent implements OnInit {
  baseUrl = environment.baseUrl;
  public allCourse: any;
  public course: any = "../../../../assets/img/c1.png";
  public avatar: any = "../../../../assets/img/avatar.png";


  constructor(private http: HttpClient, private apiService: ApisService) {}

  ngOnInit(): void {
    this.getAllCourses();
  }

  getAllCourses() {
    this.apiService.getCourses().subscribe({
      next: (data: any) => {
        // console.log('response', data);
        this.allCourse = data;
      },
      error: (err) => console.log('error', err),
    });
  }

  courses = [
    {
      image: '../../../../assets/img/c1.png',
      caption: 'Full Stack Development: Develop your Web Programming Skills',
      rating: '4.7/5 ratings',
      duration: 'Duration: 3 month',
      teacherPix: '../../../../assets/img/user.svg',
      teacherName: 'John Doe',
      teacherPost: 'CEO, Dafexy Digital',
      oldPrice: 'N200,000',
      newPrice: 'N150,000',
    },
    {
      image: '../../../../assets/img/c2.png',
      caption: 'Full Stack Development: Develop your Web Programming Skills',
      rating: '4.7/5 ratings',
      duration: 'Duration: 3 month',
      teacherPix: '../../../../assets/img/user.svg',
      teacherName: 'John Doe',
      teacherPost: 'CEO, Dafexy Digital',
      oldPrice: 'N200,000',
      newPrice: 'N150,000',
    },
    {
      image: '../../../../assets/img/c3.png',
      caption: 'Full Stack Development: Develop your Web Programming Skills',
      rating: '4.7/5 ratings',
      duration: 'Duration: 3 month',
      teacherPix: '../../../../assets/img/user.svg',
      teacherName: 'John Doe',
      teacherPost: 'CEO, Dafexy Digital',
      oldPrice: 'N200,000',
      newPrice: 'N150,000',
    },
    {
      image: '../../../../assets/img/c1.png',
      caption: 'Full Stack Development: Develop your Web Programming Skills',
      rating: '4.7/5 ratings',
      duration: 'Duration: 3 month',
      teacherPix: '../../../../assets/img/user.svg',
      teacherName: 'John Doe',
      teacherPost: 'CEO, Dafexy Digital',
      oldPrice: 'N200,000',
      newPrice: 'N150,000',
    },
    {
      image: '../../../../assets/img/c2.png',
      caption: 'Full Stack Development: Develop your Web Programming Skills',
      rating: '4.7/5 ratings',
      duration: 'Duration: 3 month',
      teacherPix: '../../../../assets/img/user.svg',
      teacherName: 'John Doe',
      teacherPost: 'CEO, Dafexy Digital',
      oldPrice: 'N200,000',
      newPrice: 'N150,000',
    },
    {
      image: '../../../../assets/img/c3.png',
      caption: 'Full Stack Development: Develop your Web Programming Skills',
      rating: '4.7/5 ratings',
      duration: 'Duration: 3 month',
      teacherPix: '../../../../assets/img/user.svg',
      teacherName: 'John Doe',
      teacherPost: 'CEO, Dafexy Digital',
      oldPrice: 'N200,000',
      newPrice: 'N150,000',
    },
  ];

  feedbacks = [
    {
      image: '../../../../assets/img/s1.png',
      caption:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation',
      name: 'John Doe',
      post: 'CEO, Dafexy Digital',
    },
    {
      image: '../../../../assets/img/s2.png',
      caption:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation',
      name: 'John Doe',
      post: 'CEO, Dafexy Digital',
    },
    {
      image: '../../../../assets/img/s3.png',
      caption:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation',
      name: 'John Doe',
      post: 'CEO, Dafexy Digital',
    },
  ];
}
